module.exports = __webpack_public_path__ + "static/media/microvix-logo.4890c2af.png";